import { Route } from "react-router";

import AddBranch from "../../pages/AddBranch";
import AddMenu from "../../pages/AddMenu";
import Branding from "../../pages/Branding";
import Combo from "../../pages/Combo";
import CustomerList from "../../pages/CustomerList";
import Dashboard from "../../pages/Dashboard";
import Discount from "../../pages/Discount";
import EditBranch from "../../pages/EditBranch";
import OrderHistory from "../../pages/OrderHistory";
import SignupBranch from "../../pages/SignupBranch";
import SocialMedia from "../../pages/SocialMedia";
import ViewBranch from "../../pages/ViewBranch";
import ViewCombo from "../../pages/ViewCombo";
import ViewMenu2 from "../../pages/ViewMenu2";
import LiveOrders from "../../pages/LiveOrders";
import ProductBulkUpload from "../../pages/ProductBulkUpload";
import Qr from "../../pages/Qr";
import DocumentsUpload from "../../pages/DocumentsUpload";

import WaiterPannelSingup from "../../pages/WaiterSingup";
import BranchBulkUpload from "../../pages/BranchBulkUpload";
import BrowserNotification from "../../pages/BrowserNotification";
export const SuperAdminroutes = () => {
  return (
    <>
      <Route
        path="/waiter/pannel/signup"
        component={WaiterPannelSingup}
      ></Route>
      <Route path="/dashboard" component={Dashboard}></Route>
      <Route path="/documents" component={DocumentsUpload} />
      <Route path="/browser-notif" component={BrowserNotification} />
      <Route path="/qr" component={Qr} />
      <Route path="/product/bulk/upload" component={ProductBulkUpload} />
      <Route path="/liveorders" component={LiveOrders} />

      <Route path="/branch/add" component={AddBranch} />
      <Route path="/view/branch" component={ViewBranch} />
      <Route exact path="/item/add" component={AddMenu} />
      <Route exact path="/view/menu" component={ViewMenu2} />
      <Route path="/combo" component={Combo} />
      <Route path="/edit/combo/:id" component={Combo} />
      <Route exact path="/view/combo" component={ViewCombo} />
      <Route path="/edit/menu/:id" component={AddMenu} />
      <Route path="/branch/edit/:id" component={EditBranch} />
      <Route exact path="/branch/bulk/upload" component={BranchBulkUpload} />
      <Route path="/discount" component={Discount} />
      <Route exact path="/order-history" component={OrderHistory} />
      <Route exact path="/customer-list" component={CustomerList} />
      <Route exact path="/branding" component={Branding} />
      <Route path="/social-media" exact component={SocialMedia} />
      <Route path="/branch/signup" component={SignupBranch} exact />
    </>
  );
};
